import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const connectorQuery = createApi({
  baseQuery,
  reducerPath: "connectorQueries",
  endpoints: (builder) => ({
    createConnector: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.connector.create)}`,
        method: "POST",
        body: data,
      }),
    }),
    getAllConnectors: builder.query<any, any>({
      query: () => ({
        url: `${formatString(endPoints.connector.getAll)}`,
        method: "GET",
      }),
    }),
    getConnectorDetails: builder.query<any, any>({
      query: ({ connector_id }) => ({
        url: `${formatString(endPoints.connector.details, {
          key: urlKeys.connector_id,
          value: encodeURIComponent(connector_id),
        })}`,
        method: "GET",
      }),
    }),
    getExternalConnector: builder.query<any, any>({
      query: ({ connector_id }) => ({
        url: `${formatString(endPoints.connector.externalData, {
          key: urlKeys.connector_id,
          value: encodeURIComponent(connector_id),
        })}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateConnectorMutation,
  useGetAllConnectorsQuery,
  useLazyGetConnectorDetailsQuery,
  useLazyGetExternalConnectorQuery,
} = connectorQuery;
